module.exports = __webpack_public_path__ + "media/images/products/cards/growth_stock-4999a01c58c7b80dc6db87c9d01b8ee4.png";